import { ModelBase } from '../../core/model/model-base';
import { CustomProperty } from './custom-property';

export class ConnectedCustomProperty extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.property = new CustomProperty(dataContext.property);
      this.mandatory = dataContext.mandatory;
    }
  }

  property: CustomProperty;
  mandatory = false;
}
